import gql from 'graphql-tag'

export const GET_PRODUCT_BRAND_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
  ) {
    getProductBrandPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
      }
    }
  }
`

export const GET_PRODUCT_BRAND_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProductBrand (
      data: {
        id: $id
      }
    ) {
      id
      titleEn
      titleRu
      titleKg
      image
    }
  }
`
